export default "__VITE_ASSET__CZCoQsMG__"